module.exports = __webpack_public_path__ + "static/media/santa_martina.715bb02a.png";